(function () {
  function applyInnerImage(visual, sizer, landscape) {
    if (!visual) return;

    const url = landscape
      ? visual.dataset.innerLandscape
      : visual.dataset.innerPortrait;

    if (!url) return;

    visual.style.backgroundImage = "url('" + url + "')";

    if (!sizer) return;

    const width = landscape
      ? sizer.dataset.widthLandscape
      : sizer.dataset.widthPortrait;
    const height = landscape
      ? sizer.dataset.heightLandscape
      : sizer.dataset.heightPortrait;

    if (width) sizer.setAttribute('width', width);
    if (height) sizer.setAttribute('height', height);

    if (sizer.src !== url) {
      sizer.src = url;
    }
  }

  function updateHeroLayout(root) {
    if (!root) return;

    const landscape = window.innerWidth > window.innerHeight;
    root.classList.toggle('pfd-static-products--landscape', landscape);
    root.classList.toggle('pfd-static-products--portrait', !landscape);

    root.querySelectorAll('.pfd-static-products__hero-inner').forEach((inner) => {
      applyInnerImage(
        inner.querySelector('.pfd-static-products__hero-inner-visual'),
        inner.querySelector('.pfd-static-products__hero-inner-sizer'),
        landscape
      );
    });
  }

  function init() {
    const root = document.querySelector('.pfd-static-products');
    if (!root) return;

    const run = () => updateHeroLayout(root);
    run();

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(run).observe(document.documentElement);
    } else {
      window.addEventListener('resize', run);
    }

    window.addEventListener('orientationchange', run);
  }

  window.pfdStaticProductsUpdateHeroLayout = updateHeroLayout;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
